import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageService, SortService, FilterService, ResizeService, FilterSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MatterService } from '../shared/services/matter.service';
import { Disbursements } from '../shared/models/participants';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { UserService } from '../shared/services/user.service';
import { ManageUserRoleService } from '../shared/services/manage-user-role.service';

@Component({
    selector: 'xp-disbursement',
    templateUrl: './disbursement.component.html',
    styleUrls: ['./disbursement.component.scss'],
    providers: [PageService, SortService, FilterService, ResizeService]
})
export class DisbursementComponent implements OnInit {
    @ViewChild('grid') public grid?: GridComponent;
    public filterSettings!: FilterSettingsModel;

    matterDropdownData: any[] = [];
    selectedMatterId?: number;
    disbursements: Disbursements[] = [];
    isGridLoading = false;
    canViewIncomeAccount = false;
    private gridReady = false;

    pageSettings = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75] };

    constructor(
        private matterService: MatterService,
        private userService: UserService,
        private manageUserRoleService: ManageUserRoleService,
    ) { }

    ngOnInit() {
        this.loadMatters();
        this.loadIncomeAccountPermission();
        this.filterSettings = { type: "Menu" };
    }

    async loadIncomeAccountPermission() {
        const role = this.userService.userDetails?.userRole;
        console.log('[Disbursement] loadIncomeAccountPermission start', { role, timestamp: Date.now(), gridReady: this.gridReady });

        if (!role) {
            console.log('[Disbursement] loadIncomeAccountPermission: no role, skipping');
            return;
        }

        const permissions = await this.manageUserRoleService.getUserPermissionsByRole(role);
        this.canViewIncomeAccount = !!permissions && (permissions.actionstepRole === 'Administrator' || permissions.accountsApprove);
        console.log('[Disbursement] permissions resolved', {
            timestamp: Date.now(),
            gridReady: this.gridReady,
            actionstepRole: permissions?.actionstepRole,
            accountsApprove: permissions?.accountsApprove,
            canViewIncomeAccount: this.canViewIncomeAccount,
        });

        this.applyIncomeAccountVisibility();
    }

    onGridCreated() {
        this.gridReady = true;
        console.log('[Disbursement] grid created', { timestamp: Date.now(), canViewIncomeAccount: this.canViewIncomeAccount });
        this.applyIncomeAccountVisibility();
    }

    private applyIncomeAccountVisibility() {
        if (!this.gridReady || !this.grid) {
            console.log('[Disbursement] applyIncomeAccountVisibility: grid not ready yet, deferring', { gridReady: this.gridReady });
            return;
        }

        // showColumns/hideColumns match by headerText unless 'field' is passed explicitly —
        // without it these calls silently no-op against the 'incomeAccount' field name.
        if (this.canViewIncomeAccount) {
            this.grid.showColumns('incomeAccount', 'field');
        } else {
            this.grid.hideColumns('incomeAccount', 'field');
        }

        console.log('[Disbursement] applyIncomeAccountVisibility applied', {
            timestamp: Date.now(),
            canViewIncomeAccount: this.canViewIncomeAccount,
            columnVisible: this.grid.getColumnByField('incomeAccount')?.visible,
        });
    }

    loadMatters() {
        this.matterService.getMatterList('', '').then(res => {
            this.matterDropdownData = res.map(m => ({
                matterId: m.number,
                displayText: `${m.number} - ${m.description}`
            }));
        });
    }

    async onMatterChange(event: any) {
        const matterId = event?.value;

        if (matterId) {
            this.selectedMatterId = matterId;
            await this.loadDisbursements(matterId);
        }
    }


    async loadDisbursements(matterId: number) {
        this.isGridLoading = true;
        try {
            this.disbursements = await this.matterService.getDisbursementList(matterId);
        } catch (err) {
            console.error(err);
            this.disbursements = [];
        } finally {
            this.isGridLoading = false;
        }
    }

    onMatterFiltering(e: FilteringEventArgs) {
        e.preventDefaultAction = true;

        const query = e.text || '';
        let id = '';
        let name = '';

        if (!isNaN(Number(query))) {
            id = query;
        } else {
            name = query;
        }

        this.matterService.getMatterList(id, name)
            .then(res => {
                const data = res.map(m => ({
                    matterId: m.number,
                    displayText: `${m.number} - ${m.description}`
                }));
                e.updateData(data);
            });
    }

}
